import React from 'react';
import { ActionButton } from './ActionButton';
import { PropTypes } from 'prop-types';

import styles from './imageCard/imageCard.module.scss';
import { Icon } from './Icon';
import { ImageCardCompact } from './ImageCardCompact';
import { ImageCardSubContent } from './imageCard/imageCardSubContent/ImageCardSubContent';


export class ImageCard extends React.Component {
  onClick = () => {
    const { isSubContentOpen, onClick } = this.props;
    if (isSubContentOpen) {
      return;
    }
    onClick();
  }

  imageClickHandler = (e) => {
    const { clickedOnImage, loadingMessage } = this.props;
    if (clickedOnImage && !loadingMessage) {
      e.stopPropagation();
      clickedOnImage();
    }
  }

  getParamValue = (label) => {
    const { params } = this.props;
    const param = params.find(param => param.label === label);
    return param ? param.value : undefined;
  }

  renderPreview = () => {
    const {
      imageSrc,
      noImageElement = null,
      loadingMessage,
      iconName,
      isOnlyPreview,
      previewClassName = '',
    } = this.props;

    return (
      <div className={`${styles.image} ${previewClassName}`} onClick={this.imageClickHandler}>
        {imageSrc ? <img src={imageSrc} alt="" /> : noImageElement}
        {loadingMessage ? <div className={styles.loading}>
          <span className={styles.loadingText}>{loadingMessage}</span>
        </div> : null}
        {!isOnlyPreview && iconName ? (
          <i className={styles.icon}>
            <Icon name={iconName} />
          </i>
        ) : null}
      </div>
    );
  }

  render() {
    const {
      className,
      title,
      imageSrc,
      actions = [],
      params = [],
      isSelected,
      noImageElement = null,
      isSubContentOpen,
      subContentTextFields,
      subContent,
      toggleSubContent,
      isCompact,
      isSkeleton,
      isOnlyPreview,
    } = this.props;

    const classNames = !isCompact ? [styles.container] : [];
    if (isSelected) {
      classNames.push('_selected');
    }
    if (isSubContentOpen) {
      classNames.push('_sub-content');
    }
    if (className) {
      classNames.push(className);
    }

    return !isOnlyPreview ? (!isCompact ? (
      <div className={classNames.join(' ')}>
        <div className={styles.wrapper} onClick={this.onClick}>
          {this.renderPreview()}
          {!isSubContentOpen ? (
            <div className={styles.content}>
              <header className={styles.header}>
                <h4 className={styles.title}>
                  {title}
                </h4>
              </header>
              <ul className={styles.list}>
                {params.map((param, key) => (
                  <li className={styles.item} key={typeof param.label === 'string' ? param.label : key}>
                    <span className={styles.itemLabel}>
                      {param.label}
                    </span>
                    <span className={styles.itemValue}>
                      {param.value}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div className={styles.subContent}>
              {subContent || (
                <ImageCardSubContent
                  textFields={subContentTextFields}
                  close={toggleSubContent}
                />
              )}
            </div>
          )}
        </div>
        {(actions.length && !isSubContentOpen) ? (
          <ActionButton className={styles.menu} actions={actions} />
        ) : null}
      </div>
    ) : (
      <ImageCardCompact
        isSkeleton={isSkeleton}
        className={classNames.join(' ')}
        title={title}
        imageSrc={imageSrc}
        size={this.getParamValue('Size:')}
        duration={this.getParamValue('Duration:')}
        onClick={this.onClick}
        noImageElement={noImageElement}
      />
    )) : this.renderPreview();
  }
}

ImageCard.propTypes = {
  className: PropTypes.string,
  imageSrc: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  actions: PropTypes.array,
  params: PropTypes.array,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  noImageElement: PropTypes.element,
  iconName: PropTypes.string,
  clickedOnImage: PropTypes.func,
  loadingMessage: PropTypes.string,
  subContent: PropTypes.element,
  isSubContentOpen: PropTypes.bool,
  subContentTextFields: PropTypes.array,
  toggleSubContent: PropTypes.func,
  isCompact: PropTypes.bool,
  isSkeleton: PropTypes.bool,
  isOnlyPreview: PropTypes.bool,
  previewClassName: PropTypes.string,
};
